import request from '@/utils/request'

let OiocApi = {

  list(data, errorback) {
    return request._post('/shop/plus.oioc.Index/list', data, errorback);
  },
  logList(data, errorback) {//获取拿货记录
    return request._post('/shop/plus.oioc.Index/logList', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.oioc.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.oioc.Setting/getSetting', data, errorback);
  },
  
}
export default OiocApi;



// WEBPACK FOOTER //
// ./src/api/oioc.js